import { useCallback, useState } from 'react';
import styled from 'styled-components';
import DialogView from '../../../components/dialog-view/DialogView';
import OrderGoodsContent, { OrderGoodsPage } from './OrderGoodsContent';
import { isDevice } from '../../../utils/device-handling/deviceDetectionUtils';
import { useNavigate } from '../../../hooks/useNavigate';
import NavigationHeader from '../components/NavigationHeader';
import { LocationDTO } from '../../../api/api';
import { resetOrderGoods } from '../../../stateManagement/reducers/orderGoodsReducer';
import { useDispatch } from 'react-redux';

interface Props {
  onClose?: () => void;
  orderGoodsToTask: boolean;
  returnToTaskDetails?: () => void;
  taskLocation?: LocationDTO;
  taskTypeId?: number;
}

const OrderGoodsView = (props: Props) => {
  const { onClose, orderGoodsToTask, returnToTaskDetails, taskLocation, taskTypeId } = props;
  const [page, setPage] = useState<OrderGoodsPage>(OrderGoodsPage.SELECT);
  const fullscreenTask = isDevice();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');

  const handleCloseDialog = useCallback(() => {
    if (orderGoodsToTask) {
      returnToTaskDetails && returnToTaskDetails();
    } else {
      onClose && onClose();
    }
    dispatch(resetOrderGoods());
  }, [dispatch, onClose, orderGoodsToTask, returnToTaskDetails]);

  const handleCloseTask = useCallback(() => {
    if (orderGoodsToTask) {
      returnToTaskDetails && returnToTaskDetails();
    } else {
      navigate(-1);
    }
    dispatch(resetOrderGoods());
  }, [dispatch, navigate, orderGoodsToTask, returnToTaskDetails]);

  const header = (handleOnClose: () => void) => {
    return page === OrderGoodsPage.SELECT ? (
      <NavigationHeader
        headerTitle={'Bestil varer'}
        onClose={handleOnClose}
        searchTerm={searchTerm}
        setSearchTerm={(text) => setSearchTerm(text)}
      />
    ) : (
      <NavigationHeader
        headerTitle={'Varekurv'}
        onBackButton={() => setPage(OrderGoodsPage.SELECT)}
        onClose={handleOnClose}
      />
    );
  };

  return (
    <>
      {fullscreenTask ? (
        <StyledContent>
          {header(handleCloseTask)}
          <OrderGoodsContent
            taskLocation={taskLocation}
            orderToUserVeicle={!orderGoodsToTask}
            onClose={handleCloseTask}
            page={page}
            setPage={setPage}
            taskTypeId={taskTypeId}
            searchTerm={searchTerm}
          />
        </StyledContent>
      ) : (
        <DialogView handleClose={handleCloseDialog}>
          <StyledDialogContent>
            {header(handleCloseDialog)}
            <OrderGoodsContent
              taskLocation={taskLocation}
              orderToUserVeicle={!orderGoodsToTask}
              onClose={handleCloseDialog}
              page={page}
              setPage={setPage}
              taskTypeId={taskTypeId}
              searchTerm={searchTerm}
            />
          </StyledDialogContent>
        </DialogView>
      )}
    </>
  );
};

const StyledDialogContent = styled.div`
  padding: 0;
  height: 90vh;
  width: 85vw;
  max-width: 1400px;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 95vw;
  }
`;

const StyledContent = styled.div`
  height: 100vh;
  width: 100vw;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: start;
  overflow: hidden;
`;

export default OrderGoodsView;
